// extracted by mini-css-extract-plugin
export default {"container":"MailNoAddresses_container__wViXB","title":"MailNoAddresses_title__mvU-C","description":"MailNoAddresses_description__hiza7","button":"MailNoAddresses_button__cx60D"};